import {BASE_URL} from '@/utils/config';
import axios from "axios";

export const axiosPublic = axios.create({
	baseURL: BASE_URL,
});
